import { render, staticRenderFns } from "./HelpCenterWebinarSkeleton.vue?vue&type=template&id=5ef4f1ff&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports